<!--begin::Form-->
<form *ngIf="!verify2fa"  class="form w-100" [formGroup]="loginForm" novalidate="novalidate" id="kt_login_signin_form"
  (ngSubmit)="submit()">
  <!--begin::Heading-->
  <div class="text-center mb-11">
    <h1 class="text-dark fw-bolder mb-3">
      Sign In
    </h1>
    <!-- <div class="text-gray-400 fw-bold fs-4">
      New Here?
      <a
        routerLink="/auth/registration"
        id="kt_login_signup"
        class="link-primary fw-bolder"
        >{{ "AUTH.GENERAL.SIGNUP_BUTTON" | translate }}</a
      >
    </div> -->
  </div>
  <!--end::Heading-->

  <!-- begin::Alert error-->
  <ng-container *ngIf="hasError">
    <div class="mb-lg-15 alert alert-danger">
      <div class="alert-text font-weight-bold">
        {{ errorMessage }}
      </div>
    </div>
  </ng-container>
  <!-- end::Alert error-->

  <!--begin::Form group-->
  <div class="fv-row mb-8">
    <label class="form-label fs-6 fw-bolder text-dark">Email</label>
    <input class="form-control bg-transparent" type="email" name="email" formControlName="email" autocomplete="off"
      [ngClass]="{
        'is-invalid': loginForm.controls['email'].value.length > 0 && loginForm.controls['email'].invalid,
        'is-valid': loginForm.controls['email'].value.length > 0 && loginForm.controls['email'].valid
      }" />
    <ng-container [ngTemplateOutlet]="formError" [ngTemplateOutletContext]="{
        validation: 'required',
        message: 'Email is required',
        control: loginForm.controls['email']
      }"></ng-container>
    <ng-container [ngTemplateOutlet]="formError" [ngTemplateOutletContext]="{
        validation: 'email',
        message: 'Email is invalid',
        control: loginForm.controls['email']
      }"></ng-container>
    <ng-container [ngTemplateOutlet]="formError" [ngTemplateOutletContext]="{
        validation: 'minLength',
        message: 'Email should have at least 3 symbols',
        control: loginForm.controls['email']
      }"></ng-container>
    <ng-container [ngTemplateOutlet]="formError" [ngTemplateOutletContext]="{
        validation: 'maxLength',
        message: 'Email should have maximum 360 symbols',
        control: loginForm.controls['email']
      }"></ng-container>
  </div>
  <!--end::Form group-->

  <!--begin::Form group-->
  <div class="fv-row mb-3">

    <label class="form-label fw-bolder text-dark fs-6 mb-0">Password</label>

    <input class="form-control bg-transparent" type="password" name="password" autocomplete="off"
      formControlName="password" [ngClass]="{
        'is-invalid': loginForm.controls['password'].value.length > 0 && loginForm.controls['password'].invalid,
        'is-valid': loginForm.controls['password'].value.length > 0 && loginForm.controls['password'].valid
      }" />
    <ng-container [ngTemplateOutlet]="formError" [ngTemplateOutletContext]="{
        validation: 'required',
        message: 'Password is required',
        control: loginForm.controls['password']
      }"></ng-container>
    <ng-container [ngTemplateOutlet]="formError" [ngTemplateOutletContext]="{
        validation: 'minlength',
        message: 'Password should have at least 3 symbols',
        control: loginForm.controls['password']
      }"></ng-container>
    <ng-container [ngTemplateOutlet]="formError" [ngTemplateOutletContext]="{
        validation: 'maxLength',
        message: 'Password should have maximum 100 symbols',
        control: loginForm.controls['password']
      }"></ng-container>

  </div>
  <!--end::Form group-->

  <!--begin::Wrapper-->
  <div class="d-flex flex-stack flex-wrap gap-3 fs-base fw-semibold mb-8">
    <div></div>

    <!--begin::Link-->
    <a routerLink="/auth/forgot-password" class="link-primary">
      Forgot Password ?
    </a>
    <!--end::Link-->
  </div>
  <!--end::Wrapper-->

  <!--begin::Action-->
  <div class="d-grid mb-10">
    <button type="submit" id="kt_sign_in_submit" class="btn btn-primary" [disabled]="loginForm.invalid">
      <ng-container *ngIf="isLoading">
        <span class="indicator-progress" [style.display]="'block'">
          Please wait...
          <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
        </span>
      </ng-container>
      <ng-container *ngIf="(isLoading) === false">
        <span class="indicator-label">Continue</span>
      </ng-container>
    </button>
  </div>

  <!--end::Action-->
</form>
<!--end::Form-->




<form
  *ngIf="verify2fa"
  class="form w-100"
  novalidate="novalidate"
  [formGroup]="twoFactorAuthForm"
  (ngSubmit)="submit2fa()"
  id="kt_login_2fa_form"
>
  <!--begin::Heading-->
  <div class="text-center mb-10">
    <!--begin::Title-->
    <h1 class="text-dark fw-bolder mb-3">
        Two factor authentication
    </h1>
    <!--end::Title-->

    <!--begin::Link-->
    <div class="text-gray-500 fw-semibold fs-6">
        We sent a verification code to your email address.
    </div>
    <!--end::Link-->
</div>
<!--begin::Heading-->

  <!-- begin::Alert error-->
  <ng-container *ngIf="hasError">
    <div class="mb-lg-15 alert alert-danger">
      <div class="alert-text font-weight-bold">
        Sorry, looks like there are some errors detected, please try again.
      </div>
    </div>
  </ng-container>
  <!-- end::Alert error-->

  <!--begin::Form group-->
  <div class="fv-row mb-8">
    <label class="form-label fw-bolder text-gray-900 fs-6">Verification code</label>
    <input
      class="form-control bg-transparent verification-code"
      formControlName="code"
      placeholder="Verification code"
      name="code"
      autocomplete="off"
      [ngClass]="{
        'is-invalid': twoFactorAuthForm.controls['code'].value.length > 0 && twoFactorAuthForm.controls['code'].invalid,
        'is-valid': twoFactorAuthForm.controls['code'].value.length > 0 && twoFactorAuthForm.controls['code'].valid
      }"
    />

    <ng-container
      [ngTemplateOutlet]="formError"
      [ngTemplateOutletContext]="{
        validation: 'required',
        message: 'Code is required',
        control: twoFactorAuthForm.controls['code']
      }"
    ></ng-container>
    <ng-container
      [ngTemplateOutlet]="formError"
      [ngTemplateOutletContext]="{
        validation: 'pattern',
          message: 'The verification code should have 6 digits',
        control: twoFactorAuthForm.controls['code']
      }"
    ></ng-container>
  </div>
  <!--end::Form group-->
  <!--begin::Form group-->
  <div class="d-flex flex-wrap justify-content-center pb-lg-0">
    <button
      type="submit"
      id="kt_password_reset_submit"
      class="btn btn-primary me-4"
    >
      <span class="indicator-label">Submit</span>
      <ng-container *ngIf="isLoading">
        <span class="indicator-progress">
          Please wait...
          <span
            class="spinner-border spinner-border-sm align-middle ms-2"
          ></span>
        </span>
      </ng-container>
    </button>
    <button
      type="submit"
      id="kt_password_reset_submit"
      class="btn btn-light btn-active-light-primary me-4"
      (click)="verify2fa=false;"
    >
      <span class="indicator-label">Cancel</span>
    </button>
  </div>
  <!--end::Form group-->
</form>
<!--end::Form-->


<ng-template #formError let-control="control" let-message="message" let-validation="validation">
  <ng-container *ngIf="control.hasError(validation) && (control.dirty || control.touched)">
    <div class="fv-plugins-message-container text-danger">
      <span role="alert">
        {{ message }}
      </span>
    </div>
  </ng-container>
</ng-template>
